<template>
  <Container type="card-full">
    <!--<div slot="header">-->
    <!-- <el-button @click="addNotice" :loading="btnLoading">新增</el-button>
      <el-button @click="chgNotice" :loading="btnLoading">修改</el-button>
      <el-button @click="delNotice" :loading="btnLoading">删除</el-button>
      <el-button @click="setPublic" :loading="btnLoading">发布</el-button>
      <el-button @click="cancelPublic" :loading="btnLoading">取消发布</el-button> -->
    <!-- <el-button @click="close">关闭</el-button> -->
    <!--</div>-->
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{ project.projectcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{ project.projectno }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{ project.pcomfullname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{ project.projectname }}</div>
          </div>
        </div>
        <!-- <div class="split-line"></div> -->
        <!-- <div class="view-row"> -->
        <!--<div class="view-field">-->
        <!--<div class="view-label">项目编号</div>-->
        <!--<div class="view-value">{{project.projectcode}}</div>-->
        <!--</div>-->
        <!--<div class="view-field">-->
        <!--<div class="view-label">项目名称</div>-->
        <!--<div class="view-value">{{project.projectname}}</div>-->
        <!--</div>-->

        <!-- <div class="view-field type">
            <div class="view-label">公告类型</div>
            <div class="view-value">
              <el-select v-model="query.pjnoticetype" :clearable="true" placeholder="全部">
                <el-option
                  v-for="item in pjnoticetypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="view-field">
          <div><el-button @click="getPageList">查询</el-button></div>
          <div class="view-value"></div>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
    <!-- <div class="split-line"></div> -->
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" @cellDblClick="viewProject" :showfooter="false"
      :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick">
      <template slot="btn">
        <div class="btn-box">
          <vxe-button type="text" icon="vxe-icon--plus" @click="addNotice" :loading="btnLoading">新增</vxe-button>
          <vxe-button type="text" icon="el-icon-position" @click="checkSetPj" :loading="btnLoading">发布</vxe-button>
          <vxe-button type="text" icon="el-icon-remove" @click="cancelPublic" :loading="btnLoading">取消发布</vxe-button>
          <vxe-button type="text" icon="el-icon-view" @click="viewPjnotice" :loading="btnLoading">预览</vxe-button>
        </div>
      </template>
    </vggrid>
    <el-dialog :close-on-click-modal="false" @close="dialogClose" :visible.sync="dialogVisible" width="80%">
      <div v-if="dialogType === 1">
        <!--结果公告-->
        <!--<project-result-notice :projectid="project.projectid"></project-result-notice>-->
      </div>
      <div v-if="dialogType === 2">
        <project-other-notice :noticeid="noticeid"></project-other-notice>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" @close="dialogClose" :visible.sync="chproVisible" width="60%">
      <el-form :model="project" ref="ruleForm" label-position="right" class="mainfrom">
        <div class="row">
          <el-form-item label="报名开始" prop="prsbmbegtime" verify>
            <el-date-picker v-model="project.prsbmbegtime" type="datetime" placeholder="选择日期时间"
              :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item label="报名截止" prop="prsbmendtime" :verify="validatebmend">
            <el-date-picker v-model="project.prsbmendtime" type="datetime" placeholder="选择日期时间"
              :picker-options="pickerOptions"></el-date-picker>
            <!--            <el-checkbox v-model="project.prsbmneedconfirm">报名需要确认</el-checkbox>-->
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item :label="`${prsflgName}开始`" prop="prsbjbegtime" :verify="validatebjbegin">
            <el-date-picker v-model="project.prsbjbegtime" type="datetime" placeholder="选择日期时间"
              :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>

          <el-form-item :label="`${prsflgName}截止`" prop="prsbjendtime" :verify="validatebjend">
            <el-date-picker v-model="project.prsbjendtime" type="datetime" placeholder="选择日期时间"
              :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chproVisible = false">取 消</el-button>
        <el-button type="primary" @click="setPublic">确 定</el-button>
      </span>
    </el-dialog>
  </Container>
</template>
<script>
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import utils from "../../assets/js/utils";
import common from "@/mixin/common";
import dayjs from "dayjs";
import ProjectOtherNotice from "../bbgl/ProjectOtherNotice";
export default {
  name: "pjnoticeIndex",
  mixins: [common],
  data() {
    return {
      project: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 86400000;
        },
      },
      chproVisible: false,
      list: [],
      pjnoticetypeList: [],
      btn: {},
      btnLoading: false,
      isOperate: false,
      dialogVisible: false,
      dialogType: 0,
      operateBtn: [
        { btncode: "CHG", btnicon: "el-icon-edit-outline", btnname: "修改" },
        { btncode: "DEL", btnicon: "el-icon-delete", btnname: "删除" },
      ],
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "pjnoticetypedesc",
          fieldtype: "C",
          title: "类型",
          calculExpr: "",
          addNewRowFlg: false,
          width: 100,
        },
        {
          field: "pjnoticetitle",
          fieldtype: "C",
          title: "主题",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "pjnoticestatusname",
          fieldtype: "C",
          title: "状态",
          calculExpr: "",
          width: 80,
          addNewRowFlg: false,
          width: 100,
        },
        {
          field: "pjnoticetime",
          fieldtype: "C",
          title: "发布时间",
          calculExpr: "",
          addNewRowFlg: false,
          formatter: ["toDateString", ""],
          width: 180,
        },
        {
          title: "操作",
          fieldtype: "C",
          calculExpr: "",
          addNewRowFlg: false,
          width: 140,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              // 原有修改/删除图标保留
              const btns = [
                <vxe-button
                  class="icon-btn"
                  icon="el-icon-edit-outline"
                  title="修改"
                  circle
                  onClick={this.vggridClick.bind(this, "CHG", row)}
                ></vxe-button>,
                <vxe-button
                  class="icon-btn"
                  icon="el-icon-delete"
                  title="删除"
                  circle
                  onClick={this.vggridClick.bind(this, "DEL", row)}
                ></vxe-button>,
              ];
              // 变更公告（未发布）进入审核流程后，追加一个状态图标：颜色/图标即当前流程状态
              const isClarify = +row.pjnoticetype === 2 && +row.pjnoticestatus === 0;
              const auditStatus = +row.noticeAuditStatus;
              if (isClarify && auditStatus === 1) {
                // 待审核（蓝）→ 查看公告页去审核
                btns.push(
                  <vxe-button
                    class="icon-btn"
                    icon="el-icon-document-checked"
                    status="primary"
                    title="待审核，点击进入审核"
                    circle
                    onClick={this.noticeAudit.bind(this, row)}
                  ></vxe-button>
                );
              } else if (isClarify && auditStatus === 2) {
                // 已通过（绿）→ 查看公告页
                btns.push(
                  <vxe-button
                    class="icon-btn"
                    icon="el-icon-circle-check"
                    status="success"
                    title="审核已通过，点击查看"
                    circle
                    onClick={this.noticeAudit.bind(this, row)}
                  ></vxe-button>
                );
              } else if (isClarify && auditStatus === 3) {
                // 已驳回（红）→ 编辑页修改后重新提交审核
                btns.push(
                  <vxe-button
                    class="icon-btn"
                    icon="el-icon-refresh"
                    status="danger"
                    title="审核已驳回，点击修改后重新提交审核"
                    circle
                    onClick={this.noticeResubmit.bind(this, row)}
                  ></vxe-button>
                );
              } else if (isClarify && auditStatus === 4) {
                // 已作废（橙）→ 编辑页修改后重新提交审核
                btns.push(
                  <vxe-button
                    class="icon-btn"
                    icon="el-icon-refresh"
                    status="warning"
                    title="审核已作废，点击修改后重新提交审核"
                    circle
                    onClick={this.noticeResubmit.bind(this, row)}
                  ></vxe-button>
                );
              }
              return [<div class="icon-btn">{btns}</div>];
            }
          }
        },
      ],
      pjnotice: {},
      alertmsg: "",
      query: {
        total: 0,
        limit: 20,
        offset: 0,
      },
    };
  },
  created() {
    this.$on("CHG", () => this.chgNotice());
    this.$on("DEL", () => this.delNotice());
  },
  activated() {
    this.getModel();
    this.init();
    this.getPjnoticetypeList();
    this.getPageList();
  },
  computed: {
    prsflgName() {
      if (this.project.prsflg == "2") {
        return "开标";
      } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
        return "报价";
      } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "报价";
      } else if (this.project.prsflg == "6") {
        return "报价";
      }
    },
  },
  components: { MenuBtn, vggrid, ProjectOtherNotice },
  methods: {
    async getModel() {
      this.project = await request({
        method: "get",
        url: "/xmgl/project/findProjectById",
        params: { projectid: this.$route.params.projectid },
      });
    },
    async getPjnoticetypeList() {
      this.pjnoticetypeList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "pjnoticetype" },
      });
    },
    // noticetypeChange () {
    //   this.getPageList()
    // },
    btnClick(code) {
      this.$emit(code);
    },
    async init() {
      this.query = {
        total: 0,
        limit: 20,
        offset: 0,
      };
      this.list = [];
      this.btnLoading = false;
      this.pjnotice = {};
    },
    vggridClick(code, row) {
      this.pjnotice = row;
      this.$emit(code, row);
    },
    btnmenuclick(btn) {
      this.btn = btn;
    },
    async close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "womIndex",
      });
    },
    async viewProject(row) {
      this.pjnotice = row.row;
      this.$router.push({
        name: "pjnoticeView",
        params: {
          pjnoticeid: this.pjnotice.pjnoticeid,
          projectid: this.pjnotice.pjnoticeprojectid,
        },
      });
    },
    validatebmend(rule, val, callback) {
      let start = dayjs(val);
      let end = dayjs(this.project.prsbmbegtime);
      // console.log(
      //   "-------dayjs(v--------",
      //   start.month() - end.month(),
      //   start.date() - end.date()
      // );
      // if (start.month() - end.month() <= 0 && start.date() - end.date() < 2) {
      //   callback(Error("报名结束不能小于等于报名开始"));
      // } else {
      //   callback();
      // }
      if (start.valueOf() <= end.valueOf()) {
        callback(Error("报名结束不能小于等于报名开始"));
      }
      else if (start.year() !== end.year()) {
        let min = 31 - (+end.date())
        if (+start.month() !== 0) {
          callback(Error("不能小于三天，请与平台管理员联系"));
        }
        else if (min + start.date() >= 2) {
          callback();
        } else {
          callback(Error("不能小于三天，请与平台管理员联系"));
        }
      }  
      else if (
        start.month() - end.month() <= 0 &&
        start.date() - end.date() < 2
      ) {
         
          callback(Error("不能小于三天，请与平台管理员联系"));
        
      } else {
        callback();
      }
    },
    validatebjbegin(rule, val, callback) {
      if (dayjs(val).valueOf() <= dayjs(this.project.prsbmendtime).valueOf()) {
        callback(Error("报价开始不能小于等于报名结束"));
      } else {
        callback();
      }
    },
    validatebjend(rule, val, callback) {
      if (dayjs(val).valueOf() <= dayjs(this.project.prsbjbegtime).valueOf()) {
        callback(Error("报价结束不能小于等于报价开始"));
      } else {
        callback();
      }
    },
    async addNotice() {
      if (+this.project.projectstatus === 50) {
        this.$message.warning("项目已归档");
        return;
      }
      this.$router.push({
        name: "pjnoticeForm",
        params: { projectid: this.project.projectid, type: 1 },
      });
    },
    async chgNotice() {
      if (+this.pjnotice.pjnoticestatus !== 0) {
        this.$message.warning("该状态不能修改！");
        return;
      }
      // 变更公告已提交审核（待审核）不允许修改，驳回/作废后可修改重新提交
      if (+this.pjnotice.pjnoticetype === 2 && +this.pjnotice.noticeAuditStatus === 1) {
        this.$message.warning("该公告已提交审核，审核中不能修改！");
        return;
      }
      this.$router.push({
        name: "pjnoticeForm",
        params: {
          pjnoticeid: this.pjnotice.pjnoticeid,
          projectid: this.project.projectid,
          type: 2,
        },
      });
    },
    async delNotice() {
      if (+this.pjnotice.pjnoticestatus !== 0) {
        this.$message.warning("该状态不能删除！");
        return;
      }
      // 变更公告：审核中/已通过不能删除；驳回/已作废可删除（审核记录随公告一并删除）
      if (+this.pjnotice.pjnoticetype === 2 && (+this.pjnotice.noticeAuditStatus === 1 || +this.pjnotice.noticeAuditStatus === 2)) {
        this.$message.warning(
          +this.pjnotice.noticeAuditStatus === 1
            ? "该公告已提交审核（审核中），不能删除！"
            : "该公告已审核通过，不能删除！"
        );
        return;
      }
      if (+this.project.projectjjbgstatus === 2 && +this.pjnotice.pjnoticetype === 3) {
        this.$message.warning("采购失败报告审核中,不能删除！");
        return;
      }
      const delMsg = +this.pjnotice.pjnoticetype === 2 && this.pjnotice.noticeAuditFlag
        ? "删除后该公告的审核记录（含确认函附件）将一并删除，确定删除?"
        : "确定删除?";
      this.$confirm(delMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.pjnotice.cosid = this.$store.getters.loginUser.cosid;
        let data = await request({
          url: "/xmgl/pjnotice/delNotice",
          method: "post",
          data: this.pjnotice,
        });
        if (data.issuccess === 1) {
          this.getPageList();
          this.$message.success("删除成功！");
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    async cellClick(row) {
      this.pjnotice = row.row;
    },
    async checkScore() {
      this.alertmsg = "";
      let res = await request({
        method: "get",
        url: "/xmgl/pg/getPgList",
        params: { projectid: this.project.projectid },
      });
      if (res.list.length) {
        let ratioTotal = res.list
          .map((t) => Number(t.pgratio))
          .reduce((a, b) => a + b);
        if (ratioTotal !== 100) {
          if (+this.project.projectpgstotalrule === 1) {
            this.alertmsg =
              '当前项目总分计算方式为"百分比"，评分项目的权重合计必须等于100，请重新设置！';
          } else {
            this.alertmsg =
              '当前项目总分计算方式为"绝对值"，评分项目的分值合计必须等于100分，请重新设置!';
          }
        }

        let scoreTotal = res.list
          .map((t) => Number(t.pgscore))
          .reduce((a, b) => a + b);
        if (+this.project.projectpgstotalrule === 2) {
          if (scoreTotal !== 100) {
            this.alertmsg = `当前项目总分计算方式为"绝对值"，评分项目的分值合计必须等于100分，请重新设置!`;
          }
        } else if (+this.project.projectpgstotalrule === 1) {
          if (scoreTotal !== 300) {
            this.alertmsg = `当前项目总分计算方式为"百分比"，评分项目的各项分值合计必须等于100分，请重新设置!`;
          }
        }
      }
    },
    async checkSetPj() {
      if (+this.project.projectstatus === 50) {
        this.$message.warning("项目已归档");
        return;
      }
      if (!this.pjnotice.pjnoticeid) {
        this.$message.warning("请选择一行！");
        return;
      }
      if (+this.pjnotice.pjnoticestatus === 1) {
        this.$message.warning("该公告已发布！");
        return;
      }
      
      if (+this.pjnotice.pjnoticetype === 6) {
        if (!this.project.project_purchasefile_confirmer) {
          this.$message.warning("温馨提示：项目的采购文件未确认，不能发布公告！")
          return;
        } else {
          this.chproVisible = true;
          return;
        }
        // if (!this.project.prsbmbegtime) {
        //   this.$message.warning("请完善项目信息!");
        //   setTimeout(() => {
        //     this.chproVisible = false;
        //     this.$router.push({
        //       name: "projectEdit",
        //       params: { projectid: this.project.projectid },
        //     });
        //   }, 900);
        //   return;
        // } else {
        //   this.chproVisible = true;
        //   return;
        // }
      } else if (+this.pjnotice.pjnoticetype === 3 && this.project.projectjjbgstatus) {
        if (+this.project.projectjjbgstatus === 2) {
          this.$message.warning("温馨提示：采购失败报告审核中，不能发布公告！")
          return 
        } else if (+this.project.projectjjbgstatus === 1 && this.pjnotice.projectjjcontent) {
          this.$message.warning("温馨提示：采购失败报告审核失败,重新提交审核通过后可以发布公告！")
          return 
        } else {
          await this.setPublic();
        }
      } else {
        await this.setPublic();
      }
    },
    async setPublic() {
      if (!this.pjnotice.pjnoticeid) {
        this.$message.warning("请选择一行！");
        this.chproVisible = false;
        return;
      }
      if (+this.pjnotice.pjnoticestatus === 1) {
        this.$message.warning("该公告已发布！");
        this.chproVisible = false;
        return;
      }
      // 提交审核的变更公告，按审核状态判断：待审核/驳回/已作废都不能发布，通过或未提交过走原流程
      if (+this.pjnotice.pjnoticetype === 2) {
        const audit = await request({
          method: "get",
          url: "/auditlog/getNoticeAuditStatus",
          params: {
            auditlogcosid: this.$store.getters.loginUser.cosid,
            auditlogfromid: this.pjnotice.pjnoticeid,
            auditlogcode: 30,
          },
        });
        const auditstatus = audit && audit.data ? +audit.data.auditstatus : 0;
        if ([1, 3, 4].includes(auditstatus)) {
          const msg = auditstatus === 1
            ? "该变更公告已提交审核，审核通过后才能发布！"
            : auditstatus === 3
              ? "该变更公告审核未通过，请修改后重新提交审核！"
              : "该变更公告内容已修改，原审核结果已作废，请重新提交审核！";
          this.$message.warning(msg);
          this.chproVisible = false;
          return;
        }
      }
      if (+this.pjnotice.pjnoticetype === 6) {
        if (+this.project.projectdoneflg === 3) {
          // let pgList = await request({
          //   method: "get",
          //   url: "/xmgl/project/getPgList",
          //   params: { projectid: this.project.projectid },
          // });
          // if (!pgList.length) {
          //   this.$message.warning("请设置评审规则!");
          //   setTimeout(() => {
          //     this.chproVisible = false;
          //     this.$router.push({
          //       name: "projectReviewRuleIndex",
          //       params: { projectid: this.project.projectid, type: 1 },
          //     });
          //   }, 900);
          //   return;
          // }
        }
        // if (+this.project.projectisqcheck === 1) {
        //   let from = {};
        //   from.pqcitemprojectid = this.project.projectid;
        //   let res = await request({
        //     method: "get",
        //     url: "/ywgl/qcm/getpqclist",
        //     params: from,
        //   });
        //   if (!res.length) {
        //     this.$message.warning("请设置初审规则!");
        //     this.chproVisible = false;
        //     setTimeout(() => {
        //       this.$router.push({
        //         name: "projectReviewRuleIndex",
        //         params: { projectid: this.project.projectid, type: 1 },
        //       });
        //     }, 900);
        //     return;
        //   }
        // }
        let nowdate = await request({
          method: "get",
          url: "xtgl/sysdata",
        });
        if (Number(this.project.projectstatus) === 10) {
          if (
            this.project.prsbmendtime !== null &&
            new Date(this.project.prsbmendtime).getTime() <=
            new Date(nowdate).getTime()
          ) {
            this.$message.warning("该项目报名已结束，请重新修改项目信息!");
            this.chproVisible = false;
            setTimeout(() => {
              this.$router.push({
                name: "projectEdit",
                params: { projectid: this.project.projectid },
              });
            }, 900);
            return;
          }
        }
        // await this.checkScore();
        if (this.alertmsg) {
          this.$message.warning(this.alertmsg);
          this.chproVisible = false;
          setTimeout(() => {
            this.btnLoading = false;
            this.$router.push({
              name: "projectReviewRuleIndex",
              params: {
                projectid: this.project.projectid,
                activeName: "pfxm",
                type: 1,
              },
            });
          }, 900);
          return;
        }
      }
      if (+this.pjnotice.projectstopflg === 1) {
        this.$message.warning("终止公告已发布，不能再发布公告");
        this.chproVisible = false;
        return;
      }
      if (+this.pjnotice.pjnoticetype === 3) {
        if (+this.pjnotice.projectcancelflg === 1) {
          this.$message.warning("失败公告已发布，不能再发布公告");
          this.chproVisible = false;
          return;
        }
      }
      if (+this.pjnotice.pjnoticetype !== 6) {
        if (+this.pjnotice.projectstatus === 10) {
          this.$message.warning("项目还未发布，不允许发布其他公告");
          this.chproVisible = false;
          return;
        }
      }
      // if(this.project.projectjgfbtime){
      //     if(this.pjnotice.pjnoticetype = 4){
      //       this.$message.warning('成交公告已发布，不可发布终止公告')
      //       return
      //     }
      //     if(this.pjnotice.pjnoticetype = 3){
      //       this.$message.warning('成交公告已发布，不可发布废标公告')
      //       return
      //     }
      // }
      if (
        +this.pjnotice.pjnoticetype === 1 ||
        +this.pjnotice.pjnoticetype === 2
      ) {
        this.pjnotice.class = 3;
      } else if (
        +this.pjnotice.pjnoticetype === 60 ||
        +this.pjnotice.pjnoticetype === 3 ||
        +this.pjnotice.pjnoticetype === 4
      ) {
        this.pjnotice.class = 2;
      } else if (+this.pjnotice.pjnoticetype === 6) {
        this.pjnotice.class = 1;
      } else if (+this.pjnotice.pjnoticetype === 5) {
        this.pjnotice.class = 4;
      }

      let model = {
        projectid: this.$route.params.projectid,
        cosid: this.$store.getters.loginUser.cosid,
        pjnoticeid: this.pjnotice.pjnoticeid,
        userid: this.$store.getters.loginUser.userid,
        type: this.pjnotice.pjnoticetype,
        pjnoticestatus: 1,
        class: this.pjnotice.class,
        pjnoticetime: utils.formatterDate(
          this.pjnotice.pjnoticetime,
          "yyyy-MM-dd HH:mm:ss"
        ),
        prsbmbegtime: utils.formatterDate(
          this.project.prsbmbegtime,
          "yyyy-MM-dd HH:mm:ss"
        ), //报名开始时间
        prsbmendtime: utils.formatterDate(
          this.project.prsbmendtime,
          "yyyy-MM-dd HH:mm:ss"
        ), //报名结束时间
        prsbjbegtime: utils.formatterDate(
          this.project.prsbjbegtime,
          "yyyy-MM-dd HH:mm:ss"
        ), //报价开始时间
        prsbjendtime: utils.formatterDate(
          this.project.prsbjendtime,
          "yyyy-MM-dd HH:mm:ss"
        ), //报价结束时间
      };

      if (+this.pjnotice.pjnoticetype === 6) {
        this.submitForm("ruleForm")
          .then(async () => {
            let res = await request({
              method: "post",
              url: "/xmgl/pjnotice/pubNotice",
              data: model,
            });
            if (res.issuccess === 1) {
              this.getPageList();
              this.newsPush();
              this.$message({
                message: '发布成功!',
                type: "success"
              })
              this.chproVisible = false;
            } else {
              this.chproVisible = false;
              this.$message.error("发布失败");
            }
          })
          .catch((err) => {
            console.log("======err======", err);
          });
      } else {
        let res = await request({
          method: "post",
          url: "/xmgl/pjnotice/pubNotice",
          data: model,
        });
        if (res.issuccess === 1) {
          this.getPageList();
          this.newsPush();
          this.$message.success("发布成功");
          this.chproVisible = false;
        } else {
          this.chproVisible = false;
          this.$message.error("发布失败");
        }
      }
    },
    async cancelPublic() {
      if (+this.project.projectstatus === 50) {
        this.$message.warning("项目已归档");
        return;
      }
      if (!this.pjnotice.pjnoticeid) {
        this.$message.warning("请选择一行！");
        return;
      }
      if (
        +this.pjnotice.pjnoticetype === 6 &&
        this.project.projectjkactualbegtime
      ) {
        this.$message.warning(
          `${this.project.prsflg === 1 ? "竞价" : "开标"
          }时间已开始 不能取消发布！`
        );
        return;
      }
      let model = {
        projectid: this.pjnotice.projectid,
        pjnoticeid: this.pjnotice.pjnoticeid,
        userid: this.$store.getters.loginUser.userid,
        type: this.pjnotice.pjnoticetype,
        pjnoticestatus: 0,
      };
      let res = await request({
        method: "post",
        url: "/xmgl/pjnotice/cancelPubNotice",
        data: model,
      });
      if (res.issuccess === 1) {
        this.getPageList();
        this.$message.success("取消发布成功");
      } else {
        this.$message.error("取消发布失败");
      }
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getPageList();
    },
    async getPageList() {
      this.query.pjnoticeprojectid = this.$route.params.projectid;
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/pjnotice/getPageList",
        params: this.query,
      });
      this.list = res.list;
      this.query.total = res.count[0].count;
      await this.setNoticeAuditFlags();
      this.loading = false;
    },
    // 给变更公告行打审核标记（auditlogcode 30）：noticeAuditFlag 有提交记录，noticeAuditStatus 0未提交 1待审核 2已通过 3已驳回 4已作废
    // 注意：行对象后加的属性必须用 $set，否则不是响应式的，单元格不会重渲染
    async setNoticeAuditFlags() {
      this.list.forEach((e) => {
        this.$set(e, "noticeAuditFlag", false);
        this.$set(e, "noticeAuditStatus", 0);
      });
      const auditList = await request({
        method: "get",
        url: "/auditlog/getNoticeAuditListByProjectid",
        params: {
          auditlogcosid: this.$store.getters.loginUser.cosid,
          pjnoticeprojectid: this.$route.params.projectid,
          auditlogcode: 30,
        },
      });
      const map = {};
      // 接口按时间倒序返回，每个公告的第一条即最新状态
      (auditList || []).forEach((i) => {
        const key = i.auditlogfromid;
        if (!map[key]) {
          map[key] = [];
        }
        map[key].push(i);
      });
      this.list.forEach((e) => {
        const records = map[e.pjnoticeid];
        if (records && records.length) {
          this.$set(e, "noticeAuditFlag", true);
          // 取最新一条有效记录（普通循环，避免运行时 Array 原型方法被改写的影响）
          let latest = null;
          for (let n = 0; n < records.length; n++) {
            const t = +records[n].auditlogtype;
            if (t === 1 || t === 2 || t === 3) {
              latest = records[n];
              break;
            }
          }
          let status = 0;
          if (latest) {
            if (+latest.auditlogtype === 1) {
              status = 1;
            } else if (+latest.auditlogtype === 2) {
              status = +latest.auditresult === 1 ? 2 : 3;
            } else {
              status = 4;
            }
          }
          this.$set(e, "noticeAuditStatus", status);
        }
      });
    },
    // 审核提交审核的变更公告
    async noticeAudit(row) {
      if (+row.pjnoticestatus !== 0) {
        this.$message.warning("该公告已发布，不能审核！");
        return;
      }
      this.$router.push({
        name: "pjnoticeView",
        params: {
          pjnoticeid: row.pjnoticeid,
          projectid: row.pjnoticeprojectid,
          isaudit: 1,
        },
      });
    },
    // 驳回/已作废后的变更公告：进入编辑页修改并重新提交审核
    async noticeResubmit(row) {
      this.pjnotice = row;
      await this.chgNotice();
    },
    async viewPjnotice() {
      if (!this.pjnotice.pjnoticeid) {
        this.$message.warning("请选择一行！");
        return;
      }
      // if (this.pjnotice.pjnoticetype) {
      //   this.noticeid = this.pjnotice.pjnoticeid
      //   this.dialogVisible = true
      //   this.dialogType = 2
      // } else {
      //   this.dialogVisible = true
      //   this.dialogType = 1
      // }
      // let { href } = this.$router.resolve({
      //   name: "pjothernotice",
      //   query: { pjnoticeid: this.pjnotice.pjnoticeid },
      // });
      const env = this.$store.getters.env
      let href = 'http://localhost:8080/#/'
      switch (env) {
        case 'ttenv':
            href='http://tt.eebidding.com/#/'
          break;
        case 't':
            href='http://t.eebidding.com/#/'
          break;
        case 'production':
            href='http://j.eebidding.com/#/'
      }
      window.open(`${href}pjnoticeInfo?pjnoticeid=${this.pjnotice.pjnoticeid}&projectid=${this.project.projectid}`, "_blank");
    },
    async newsPush() {
      let model = {};
      model.projectid = this.project.projectid;
      model.cosid = this.$store.getters.loginUser.cosid;
      model.type = this.pjnotice.pjnoticetypedesc;
      model.userid = this.project.projectcuserid;
      await request({
        method: "post",
        url: "/info/rush/pushAnnouncement",
        data: model,
      });
      if (+this.pjnotice.pjnoticetype === 60) {
        await request({
          method: "post",
          url: "/info/rush/pushDealNotice",
          data: model,
        });
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.chproVisible = false;
      this.dialogType = 0;
    },
  },
  filters: {},
};
</script>
<style lang="scss">
.btn-box {
  overflow: hidden;

  .vxe-button {
    padding: 10px 10px;
    font-size: 16px;
  }
}

.type {
  display: flex;
  align-items: center;
}

.icon-btn {
  display: flex;
  align-items: center;

  .vxe-button {
    font-size: 17px !important;
  }
}
</style>
